const events = [
  {
    emoji: "📚",
    date: "set 24",
    text: (
      <>
        Foi lá na Bienal do Livro que nos conhecemos
        <br />
        (ainda bem que eu nunca tinha ido)
      </>
    ),
  },
  {
    emoji: "🎄",
    date: "dez 24",
    text: "Rolou o pedido de namoro e passamos nosso primeiro Natal juntos",
  },
  {
    emoji: "🏠",
    date: "jul 25",
    text: 'Decidimos dividir o mesmo teto para não precisar mais "ir embora"',
  },
  {
    emoji: "🔑",
    date: "dez 25",
    text: "Compramos o nosso primeiro apartamento pra ter o nosso cantinho",
  },
  {
    emoji: "🚗",
    date: "mar 26",
    text: "E logo veio o notre (muito aguardado) voiture também",
  },
  {
    emoji: "💍",
    date: "abr 26",
    text: "Nossa primeira viagem para a França e o pedido de noivado (que foi aceito)",
  },
  {
    emoji: "🔨",
    date: "mai 26",
    text: "Começamos nossa primeira obra juntos. Com um papel, o Figma e um sonho",
  },
  {
    emoji: "♾️",
    date: "Pra sempre",
    text: "A vida segue... cada dia mais bonita, cada dia amando mais e mais...",
  },
];

function Timeline() {
  return (
    <div
      id="timeline"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1 className="mb-5">Linha do tempo</h1>
        <div className="timeline">
          {events.map((ev, i) => (
            <div key={i} className="timeline-item">
              {i < events.length - 1 && <div className="timeline-connector" />}
              <div className="timeline-dot">
                <span style={{ fontSize: "22px", lineHeight: 1 }}>{ev.emoji}</span>
              </div>
              <div className="timeline-content">
                <p className="timeline-date">{ev.date}</p>
                <h3>{ev.text}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Timeline;
